<div [class]="styleClass" [ngClass]="{
  'autocomplete': true,
  'autocomplete-primary': theme === 'primary',
  'autocomplete-secondary': theme === 'secondary',
  'autocomplete-light': theme === 'light',
  'autocomplete-border': theme === 'border',
  'active': isActive,
  'input-icon-left': leftIcon,
  'input-icon-right': rightIcon,
  'has-edit-field': (hasCustomEditableField || hasEditableField)
  }" #autoCompleteContainer>
  <div class="autocomplete-wrapper">
    <!-- Start Input Wrapper -->
    <div [class]="styleClassInputWrapper" [ngClass]="{
        'autocomplete-input-wrapper form-group flex-column': true,
        'active': isDropdownExpanded || isActive,
        'error': hasError,
        'invalid': isInvalid,
        'autocomplete-disabled': disabled,
        'hover-effect': hasHoverEffect,
        'active-bg': hasBgOnActive,
        'float-label': isActive || value?.length > 0 || query?.length > 0,
        'no-active-border-bottom': !hasBorderBottomOnActive,
        'input-icon-left': leftIcon,
        'input-icon-right': rightIcon,
        'disabled': disabled
      }" #autoCompleteInputWrapper>
      <div class="flex-start-center">
        <i [class]="leftIcon" (click)="onFocus(true)" [ngClass]="{'icon left-icon': true}"></i>
        <img [src]="imgIcon" class="imgIcon" [ngClass]="imgIconClass" *ngIf="imgIcon">
        <div class="width-100p position-relative" [ngClass]="{'d-flex': isLoadingData}">
          <input autocomplete="off" id="{{id}}" autocorrect="off" spellcheck="false" type="text" [name]="name"
            [style.color]="textColor" [hidden]="allowMultiline" [class]="styleClassInput"
            [ngStyle]="{fontSize: fontSize + 'px'}" [ngModel]="value || ''" [disabled]="disabled" [value]="value || ''"
            [ngClass]="{'autocomplete-input': true, 'input-elipses': textTruncate, 'disabled': disabled, 'not-allowed': disabled && showDisabledIcon, 'autocomplete-float-input': floatingLabel}"
            [placeholder]="placeholder" [mask]="mask" [prefix]="prefix" (blur)="onBlur()" (focus)="onFocus(true)"
            (keyup)="onChange($event)" (paste)="onPaste($event)" (keydown.shift.tab)="onEscPress($event, 'shift-tab')" (keydown.enter)="onEnter()"
            (keydown.tab)="onTabPress()" (keydown.esc)="onEscPress($event)" (keydown.arrowdown)="onSelectOption('down')"
            (keydown.arrowup)="onSelectOption('up')" #autoCompleteInputControl [readonly]="readonly"
            [maxLength]="maxLength">

          <textarea autocomplete="off" id="V{{textAreaId}}" autocorrect="off" spellcheck="false" type="text" [rows]="1"
            [hidden]="!allowMultiline" [class]="styleClassInput" [ngStyle]="{fontSize: fontSize + 'px' }" [name]="name"
            [ngModel]="value || ''" [disabled]="disabled" [placeholder]="placeholder" [mask]="mask" [prefix]="prefix"
            [ngClass]="{'autocomplete-input': true, 'disabled': disabled, 'not-allowed': disabled && showDisabledIcon, 'autocomplete-float-input': floatingLabel}"
            (blur)="onBlur()" (focus)="onFocus(true)" (keyup)="onChange($event)"
            (keydown.shift.tab)="onEscPress($event)" (keydown.enter)="onEnter()" (keydown.tab)="onTabPress()"
            (keydown.esc)="onEscPress($event)" (keydown.arrowdown)="onSelectOption('down')"
            (keydown.arrowup)="onSelectOption('up')" #textareaControl></textarea>

          <div *ngIf="disabled" class="input-click-overlay"
            [ngStyle]="{'width': (allowMultiline? textareaControl?.offsetWidth : autoCompleteInputControl?.offsetWidth) + 'px'}"
            (click)="onInputFieldClick()"></div>
          <div *ngIf="isLoadingData"
            class="fal fa-spinner rotate font-16 d-flex justify-content-center align-items-center"></div>
        </div>

        <span class="header-btn pointer font-12" id="browse-{{id}}" [hidden]="!hasHeaderButton"
          [class]="headerButtonClass" (click)="handleHeaderBtnClick()">
          <img [src]="headerButtonIcon" class="headerButtonIcon" *ngIf="headerButtonIcon">
          {{ headerButtonTitle }}
        </span>
        <span *ngIf="isActive">
          <i class="icon fa fa-times-circle mr-4 font-gray-600 font-12 pointer" *ngIf="isClearIconVisible" (click)="onCancelEdit()"></i>
        </span>

        <i class="icon fal fa-chevron-down font-12 pointer" [hidden]="!isDropdownIconVisible"
          (click)="onFocus();onDropdownIconClick();"
          [ngClass]="{'fa-chevron-down': !isDropdownExpanded, 'fa-chevron-up': isDropdownExpanded}"></i>

        <label id="label-{{id}}" [hidden]="!floatingLabel" [class]="styleClassLabel"
          [ngClass]="{'disabled': disabled, 'autocomplete-label': true, 'app-label-float': floatingLabel}"
          (click)="onFocus(true)">
          {{isDropdownExpanded || value?.length > 0 || query?.length > 0? label : placeholder}}
        </label>

        <div [ngClass]="{'app-input-error': true}" [class]="styleClassError">
          {{errorMessage}}
        </div>
      </div>
    </div>
    <!-- End Start Wrapper -->

    <!-- Start List Wrapper -->
    <div class="autocomplete-list-wrapper" [class]="styleClassListWrapper"
      [hidden]="!hasCustomEditableField && !hasEditableField && !suggestions?.length && suggestions?.length !== 0 && !isLoading"
      [ngStyle]="{minWidth: itemWidth? itemWidth: '100%'}" [ngClass]="{
          'show': isDropdownExpanded,
          'list-top': vPosition === 'top',
          'list-bottom': vPosition === 'bottom',
          'list-left': hPosition === 'left',
          'list-right': hPosition === 'right',
          'border-padding-a': hasCustomEditableField || hasEditableField || suggestions?.length || isLoading || query?.length >= minSearchLength,
          'no-upper-border': (!suggestions ||suggestions?.length === 0) && !hasEditableField
        }" #autoCompleteListWrapper>
      <div [hidden]="!hasListHeader" class="flex-between-center list-header">
        <span class="font-11" [ngClass]="{'font-10': fontSize === 10}"> {{listHeaderTitle}}</span>
      </div>

      <div class="result-for" [hidden]="!hasListHeaderData">
        <div class="rf-header">
          <h4>SEARCH RESULTS FOR</h4>
          <p>
            <a>{{hasListHeaderData?.customer?.phone}}</a>
            <a>{{hasListHeaderData?.customer?.email}}</a>
          </p>
        </div>
      </div>

      <!--START:- Default Search Only used in appointment request  -->
      <ul *ngIf="!hasCustomListTemplate && hasListHeaderData" [id]="listId" [class]="styleClassList + ' apt-list-user'"
        [ngClass]="{'autocomplete-list': true, 'list-border': hasEditableField || hasCustomEditableField || defaultSuggestions?.length}"
        [ngStyle]="{'max-height': scrollHeight, 'minWidth': itemWidth? itemWidth: '100%'}" #autoCompletedList>
        <li [hidden]="!hasStaticListHeader" class="flex-between-center list-header">
          <span> {{staticListHeaderTitle}}</span>
        </li>

        <li *ngFor="let option of defaultSuggestions; let idx = index" [id]="'item-' + id + idx" [hidden]="isLoading"
          [ngStyle]="{minWidth: itemWidth? itemWidth: '100%', fontSize: listItemFontSize + 'px'}"
          [class]="styleClassListItem +' d-flex search-border-top'" (click)="onSelect(option)"
          [ngClass]="{'autocomplete-list-item': true, 'highlighted-item': selectedOptionIndex === idx}">
          <i class="far fa-user"></i>
          <span *ngIf="!autocompleteItem" class="p-1">{{resolveFieldData(option)}}</span>
          <ng-container
            *ngTemplateOutlet="autocompleteItem; context: { $implicit: option, query: query, index: idx, close: onCloseFromOutside, editItem: editItem, editableItemId: editableItemId }">
          </ng-container>
        </li>

        <li class="auto-complete-list-item-static bg-white" [ngStyle]="{minWidth: itemWidth? itemWidth: '100%'}"
          [hidden]="!(defaultSuggestions?.length === 0)">
          <div class="overlay no-result-found">
            <div><i class="{{noRecordIcon}}"></i>{{noRecordText}}</div>
          </div>
        </li>
      </ul>
      <!--END:- Default Search Only used in appointment request  -->


      <div class="result-for" [hidden]="!hasListHeaderData">
        <div class="rf-header">
          <h4>SEARCH RESULTS FOR</h4>
          <p>{{query?query:value}}</p>
        </div>
      </div>

      <ul *ngIf="!hasCustomListTemplate" [id]="listId" [class]="styleClassList"
        [ngClass]="{'autocomplete-list': true, 'list-border': hasEditableField || hasCustomEditableField || suggestions?.length}"
        [ngStyle]="{'max-height': scrollHeight, 'minWidth': itemWidth? itemWidth: '100%'}" (scroll)="onScroll($event)"
        #autoCompletedList>
        <li [hidden]="!hasStaticListHeader" class="flex-between-center list-header">
          <span> {{staticListHeaderTitle}}</span>
        </li>

        <li *ngFor="let option of suggestions; let idx = index" [id]="'item-' + id + idx" [hidden]="isLoading"
          [ngStyle]="{minWidth: itemWidth? itemWidth: '100%', fontSize: listItemFontSize + 'px'}"
          [class]="styleClassListItem"
          [ngClass]="{'autocomplete-list-item': true, 'highlighted-item': selectedOptionIndex === idx}"
          (click)="onSelect(option)">
          <span *ngIf="!autocompleteItem" class="p-1">{{resolveFieldData(option)}}</span>

          <ng-container
            *ngTemplateOutlet="autocompleteItem; context: { $implicit: option, query: query, index: idx, close: onCloseFromOutside, editItem: editItem, editableItemId: editableItemId }">
          </ng-container>
        </li>

        <li class="auto-complete-list-item-static " [hidden]="query  || !hasStaticUnassignedFiled"
          (click)="onSelect({ name:'Unassigned', _id: 'null' })" [ngStyle]="{minWidth: itemWidth? itemWidth: '100%'}">
          <ng-container *ngTemplateOutlet="autocompleteItemStatic">
          </ng-container>
        </li>

        <li [hidden]="!isLoading">
          <div class="overlay">
            <div class="overlay p-3 flex-center-center">
              <div class="fal fa-spinner rotate font-16"></div>
            </div>
          </div>
        </li>

        <li class="auto-complete-list-item-static bg-white" [ngStyle]="{minWidth: itemWidth? itemWidth: '100%'}"
          [hidden]="!(suggestions?.length === 0) || !(query?.length >= 3) || isLoading">
          <div class="overlay no-result-found">
            <div><i class="{{noRecordIcon}}"></i>{{noRecordText}}</div>
          </div>
        </li>

        <li class="auto-complete-list-item-static bg-white" [ngStyle]="{minWidth: itemWidth? itemWidth: '100%'}"
          [hidden]="!(suggestions?.length === 0) || !(isShowNoRecordForceFully) || isLoading">
          <div class="overlay no-result-found">
            <div><i class="{{noRecordIcon}}"></i>{{noRecordText}}</div>
          </div>
        </li>
      </ul>

      <ul [hidden]="!hasCustomListTemplate || !autoCompletedList" [id]="listId" [class]="styleClassList"
        [ngClass]="{'autocomplete-list': true, 'list-border': hasEditableField || hasCustomEditableField || suggestions?.length}"
        [ngStyle]="{'max-height': scrollHeight, 'minWidth': itemWidth? itemWidth: '100%'}" (scroll)="onScroll($event)"
        #autoCompletedList>
        <ng-container
          *ngTemplateOutlet="autoCompletedListTemplate; context: {$implicit: suggestions, query: query, close: handleClose, selectedIndex: selectedOptionIndex}">
        </ng-container>
      </ul>

      <div *ngIf="autocompleteItemStatic || autocompleteItemEditable || hasEditableField"
        class="autocomplete-list-static"
        [ngClass]="{'no-upper-border': !suggestions || suggestions?.length === 0, 'edit-mode-active': isEditable}">

        <!-- Start Static Field -->
        <div [hidden]="!query && !value" *ngIf="autocompleteItemStatic" class="auto-complete-list-state bg-white"
          (click)="onSelect({ name:'Unassigned', _id: 'null' })">
          <ng-container *ngTemplateOutlet="autocompleteItemStatic">
          </ng-container>
        </div>
        <!-- End Static Field -->

        <!-- Start Create Field Section -->
        <div *ngIf="hasEditableField && !hasCustomEditableField"
          [ngClass]="{'no-upper-border': !suggestions || suggestions?.length === 0}" class="autocomplete-item-create"
          #createField>
          <!-- Show if query length is less then 3 and editable mode is off -->
          <span id="create-btn-{{id}}" class="highlighted-text pointer" [hidden]="query?.length >= 3 || isEditable"
            [ngStyle]="{fontSize:fontSize + 'px' }" [ngClass]="{'disabled': disabled}" (click)="toggleEditMode()">
            {{ editFieldLabel }}
          </span>

          <!-- Show if query length is greater then 3 and editable mode is off -->
          <div [hidden]="hasCustomEditableField || isEditable || query?.length < 3" class="flex-between-center">
            <span class="query" [ngStyle]="{fontSize: fontSize + 'px'}" [ngClass]="{'disabled': disabled}">
              {{query}}
            </span>

            <span class="highlighted-text pointer" [ngStyle]="{fontSize: fontSize + 'px'}"
              [ngClass]="{'disabled': disabled}" (click)="toggleEditMode()">
              {{editFieldLabel}}
            </span>
          </div>

          <!-- Show if isEditable is true and query length is greater than 3 -->
          <div [hidden]="hasCustomEditableField || !isEditable" class=" width-100 bg-body"
            [ngClass]="{'flex-column': hasFutureSelectionField, 'disabled': disabled }">
            <div
              [ngClass]="{'flex-column': hasColorSelection, 'flex-center-start': hasColorSelection, 'flex-start-center': !hasColorSelection}">
              <input id="add-new-{{id}}" type="text" [placeholder]="editFieldPlaceholder" [maxlength]="maxLength"
                class="pl-3p create-field width-100p" [ngClass]="{'mb-2':hasColorSelection || hasFutureSelectionField }"
                [(ngModel)]="query" (keyup)="onChangeType($event)" [ngStyle]="{fontSize: fontSize + 'px'}"
                [ngClass]="{'disabled': disabled}" #createInput autocomplete="off">

              <span class="flex-wrap" [ngStyle]="{fontSize: fontSize + 'px'}"
                [ngClass]="{'flex-between-center width-100p': hasColorSelection, 'disabled': disabled}">
                <div [hidden]="!hasColorSelection" class="color-circle-wrapper">
                  <div *ngFor="let color of colors" class="color-circle flex-center-center"
                    [ngStyle]="{'background-color': color.value}" (click)="onColorSelect(color.value)"
                    [ngClass]="{active:color.value === selectedColor}">

                    <i [ngStyle]="{'opacity': (color.value !== selectedColor)? 0 : 1}"
                      class="icon fal fa-check font-12 font-white"></i>
                  </div>
                </div>
              </span>
            </div>

            <div class="pl-3p" [hidden]="!hasFutureSelectionField || editableItemId">
              <app-checkbox label="Save for future use" [isChecked]="isSaveForFuture"
                (appChange)="onFutureSaveClick($event)"></app-checkbox>
            </div>

            <div class="" [hidden]="!isShowError">
              <span class="font-12 font-error">Category name already exists</span>
            </div>
            <div class="update-action flex-end-center mt-2">
              <button class="btn btn-white pt-1 pb-1 mr-1" (click)="onCancelEdit()">Cancel</button>
              <button class="btn btn-primary pt-1 pb-1" [id]="'add-new-btn-' + id"
                [disabled]="_trim(query)?.length < 3 || isShowError"
                [ngClass]="{'disabled': _trim(query)?.length < 3, 'disabled': disabled }"
                (click)="onCreate()">{{createButtonTitle}}</button>
            </div>
          </div>
        </div>
        <!-- End Create Field Section -->

        <!-- Start Custom Create Item Field -->
        <div *ngIf="hasCustomEditableField" [ngClass]="{'no-upper-border': !suggestions || suggestions?.length === 0}"
          class="custom-create-field font-primary pointer" (click)="toggleEditMode()">
          <ng-container *ngTemplateOutlet="autocompleteItemEditable; context: {
              $implicit: closeSuggestions,
              clearQueries: clearQueries,
              close: onCloseFromOutside
            }">
          </ng-container>
        </div>
        <!-- End Custom Create Item Field -->
      </div>

    </div>
    <!-- Start List Wrapper -->
  </div>
</div>
